import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const getEditorStyle = (
  validationError: string,
  hasHeader?: boolean,
  hasFooter?: boolean,
): string => {
  const error = validationError && "pill-picker-error";
  const grow = "grow-extra-long-editor";
  const noTopRadius = hasHeader ? "no-top-radius" : "";
  const noBottomRadius = hasFooter ? "no-bottom-radius" : "";
  return [error, grow, noTopRadius, noBottomRadius].filter(Boolean).join(" ");
};

export const StyledEditorWithHeaderFooter = styled.div`
  display: flex;
  flex-direction: column;

  .header-footer-item {
    overflow: hidden;
    border-left: 1px solid ${GrayColors["G-1-5"]};
    border-right: 1px solid ${GrayColors["G-1-5"]};

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: inherit !important;
    }

    img,
    picture,
    video {
      max-width: 100%;
      height: auto;
    }
  }

  .header-footer-item--header {
    border-top: 1px solid ${GrayColors["G-1-5"]};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .header-footer-item--footer {
    border-bottom: 1px solid ${GrayColors["G-1-5"]};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:has(> .header-footer-item--footer) .react-input-group--white-new {
    box-shadow: none !important;
  }
`;

export const StyledPillPickerEditorWrapper = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: inherit;
  }

  .is-active {
    .empty-node {
      visibility: visible;
    }
  }

  .is-default {
    .empty-node {
      visibility: hidden;
    }
  }

  .pill-picker-editor__plus-button {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  .editor-toolbar {
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #f3f3f4;
  }

  .grow-extra-long-editor {
    .ProseMirror {
      min-height: 200px;
      max-height: initial;
      padding: 7px 8px;

      p {
        line-height: 25px;
        vertical-align: middle;
      }
      .pill-node-view-wrapper {
        margin-left: 4px;
        margin-right: 0px;
        display: inline-flex;
        max-width: 100%;
        margin-right: 0px;
        vertical-align: middle;

        .field-type-pill {
          max-width: 100%;
          margin: 0 4px 0 0;
          position: relative;
          top: -1px;
        }
      }
    }
  }

  .grow-long-editor {
    .ProseMirror {
      min-height: 55px;
      max-height: initial;
    }
  }

  .one-line-editor {
    .ProseMirror {
      min-height: initial;
      max-height: initial;
    }
  }

  .pill-picker-editor__editor {
    width: 100%;
  }

  .no-top-radius,
  .no-top-radius .pill-picker-editor__editor {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .no-bottom-radius,
  .no-bottom-radius .pill-picker-editor__editor {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .empty-node:before {
    color: ${GrayColors["G-4"]};
  }
  /* .editor.pill-picker-editor__editor > .ProseMirror[contenteditable] {
    .field-type-pill {
      margin: 0 6px 0 6px;
      position: relative;
      top: -1px;
    }

    min-width: 100px !important;
    font-size: 13px !important;
    padding: 3px 12px 12px 12px;

    p {
      margin-bottom: 0 !important;
      line-height: 26px;
    }
  } */
`;
